import { Input } from 'lynkco-up-core';
import { UpdateApplications, UpdateVersions } from '../../modules/UpdateManagement/types';
import { BaseSyntheticEvent, useEffect } from 'react';
import React from 'react';

type prop = {
  versionsObject: UpdateVersions | undefined;
  setVersionsObject: React.Dispatch<React.SetStateAction<UpdateVersions | undefined>>;
  applications: UpdateApplications[] | undefined;
  filteredModel: string;
};

const newVersionObject: UpdateVersions = {
  applicationName: '',
  packageName: '',
  version: '',
  releaseNote: '',
  status: '',
};

function CreateVersionForm({
  versionsObject = newVersionObject,
  setVersionsObject,
  applications,
  filteredModel,
}: prop) {
  const isNewCar = filteredModel === 'CX11_A3,E335,DX11';
  const filteredApps = applications?.filter(({ name }) => (isNewCar ? name.endsWith(' NV') : !name.endsWith(' NV')));
  filteredApps?.map(({ name }) => (name = name.replaceAll(' NV', '')));

  const maxLength = Number(process.env.REACT_APP_COLAB_COMMENT_MAX_LENGTH) || 200;
  const stringLength = versionsObject.releaseNote?.length || 0;
  const remainingCharacters = maxLength - stringLength;

  function handleApplication(event: BaseSyntheticEvent): void {
    const index = event.target.value;
    const app = filteredApps?.at(index);
    if (versionsObject) {
      setVersionsObject({
        ...versionsObject,
        applicationName: app?.name || '',
        packageName: app?.packageName || '',
      });
    }
  }

  function handleInput(event: BaseSyntheticEvent): void {
    const name = event.target.name;
    const value = event.target.value;
    if (versionsObject) {
      setVersionsObject({
        ...versionsObject,
        [name]: value,
      });
    }
  }

  useEffect(() => {
    if (filteredApps) {
      setVersionsObject({
        ...versionsObject,
        applicationName: filteredApps[0]?.name || '',
        packageName: filteredApps[0]?.packageName || '',
        status: 'OPTIONAL',
      });
    }
  }, []);

  return (
    <form className="mt-4 flex flex-col">
      <section className="my-0.5">
        <select className="w-36" name="applications" onChange={handleApplication}>
          {filteredApps?.map((entity, index) => {
            return (
              <option key={index} value={index}>
                {entity.name.replaceAll(' NV', '')}
              </option>
            );
          })}
        </select>
      </section>
      <section className="my-0.5">
        <Input name="version" onChange={handleInput} placeholder="Version" />
      </section>

      <section className="my-1.5">
        <textarea
          className={'resize-y w-80 min-h-max max-h-72'}
          placeholder="Release Note"
          rows={4}
          value={versionsObject.releaseNote}
          name="releaseNote"
          onChange={handleInput}
          maxLength={maxLength}></textarea>

        <div className="flex items-center justify-between text-sm text-gray-500 mt-1">
          <span className={remainingCharacters ? 'invisible' : 'text-red-500'}>Maximum characters used.</span>
          <span>{`${remainingCharacters} / ${maxLength}`}</span>
        </div>
      </section>

      <section className="my-0.5">
        <select className="w-36" name="status" onChange={handleInput}>
          <option value={'OPTIONAL'}>Optional</option>
          <option value={'MANDATORY'}>Mandatory</option>
          <option value={'BLOCKED'}>Blocked</option>
        </select>
      </section>
    </form>
  );
}

export default CreateVersionForm;
